import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { PublicMasterListService } from '@supoui/core/services/public-master-list.service';
import { IncomingCasesTaskViewModel } from '@supoui/shared/components/task-web-modal/models/incoming-cases-task-view-model';
import { ModalDialogConfiguration } from '@supoui/shared/model/modal/modal-dialog-configuration';
import { TaskType } from '@supoui/shared/model/enumerations/task-enums';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';

@Component({
    selector: 'app-task-web-modal',
    templateUrl: './task-web-modal.component.html',
    styleUrls: ['./task-web-modal.component.scss'],
    standalone: false
})
@UntilDestroy({ checkProperties: true })
export class TaskWebModalComponent implements OnInit, OnDestroy {
  @Output() closed = new EventEmitter<number>();

  serviceOrderLabel: string | undefined;
  taskDataViewModel: IncomingCasesTaskViewModel;

  modalDialogConfiguration: ModalDialogConfiguration;

  constructor(private publicMasterListService: PublicMasterListService, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  init(taskDataViewModel: IncomingCasesTaskViewModel, serviceOrderLabel?: string): void {
    this.taskDataViewModel = taskDataViewModel;
    this.serviceOrderLabel = serviceOrderLabel;
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      header: this.taskDataViewModel.taskType === TaskType.processGopRequest ? 'GOP request' : 'Original claim form'
    });
  }

  ngOnDestroy(): void {}

  close(): void {
    this.closed.emit();
  }
}
